module.exports = "https://static.wmbcdn.com/uniweb/images/68cfaff25f1248a63e17cba9bf5cb885.svg";